import { Action } from "redux"

import { removeTile, reorderTiles } from "../../util/Grid"
import * as actions from "./actions"
import { IWelcomePage } from "./index"

export const initialState: IWelcomePage = {
    greeting: "",
    userName: "",
    workspacesInfo: {
        filter: "",
        offset: 0,
        limit: 10,
        workspaces: [],
        hasMore: false,
        isLoading: false,
        isLoadingMore: false,
        noWorkspacesMessage: "",
        noWorkspacesFoundLabel: "",
        noWorkspacesFoundFilteredLabel: "",
    },
    isLoading: false,
    grid: {
        id: -1,
        tiles: [],
    },
}

const ACTION_HANDLERS: {
    [action: string]: (state: IWelcomePage, props: Action) => IWelcomePage
} = {
    [actions.INITIALIZE]: (
        state,
        {
            greeting,
            userName,
            noWorkspacesFoundLabel,
            noWorkspacesFoundFilteredLabel,
        }: actions.Initialize,
    ): IWelcomePage => ({
        ...state,
        greeting,
        userName,
        workspacesInfo: {
            ...state.workspacesInfo,
            noWorkspacesFoundLabel,
            noWorkspacesFoundFilteredLabel,
        },
    }),

    [actions.REQUEST_WORKSPACES]: (
        state,
        { filter, offset, limit }: actions.RequestWorkspaces,
    ): IWelcomePage => ({
        ...state,
        workspacesInfo: {
            ...state.workspacesInfo,
            filter,
            offset,
            limit,
            isLoading: true,
            isLoadingMore: filter === state.workspacesInfo.filter,
        },
    }),

    [actions.RECEIVE_WORKSPACES]: (
        state,
        { workspaces, hasMore }: actions.ReceiveWorkspaces,
    ): IWelcomePage => ({
        ...state,
        workspacesInfo: {
            ...state.workspacesInfo,
            workspaces: state.workspacesInfo.isLoadingMore
                ? state.workspacesInfo?.workspaces?.concat(...workspaces)
                : workspaces,
            hasMore: hasMore,
            isLoading: false,
            isLoadingMore: false,
            noWorkspacesMessage:
                workspaces.length === 0
                    ? state.workspacesInfo.filter
                        ? state.workspacesInfo.noWorkspacesFoundFilteredLabel
                        : state.workspacesInfo.noWorkspacesFoundLabel
                    : "",
        },
    }),

    [actions.REQUEST_GRID]: (state): IWelcomePage => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_GRID]: (
        state,
        { grid }: actions.ReceiveWelcomePageGrid,
    ): IWelcomePage => ({
        ...state,
        isLoading: false,
        grid,
    }),

    [actions.UPDATE_TILES_ORDER]: (
        state,
        {
            oldIndex,
            reorderedTileId,
            targetIndex,
            targetTileId,
        }: actions.UpdateTilesOrder,
    ): IWelcomePage => {
        const grid = state.grid
        const newTiles = reorderTiles(
            grid.tiles,
            targetIndex,
            oldIndex,
            reorderedTileId,
            targetTileId,
        )
        return {
            ...state,
            grid: {
                ...grid,
                tiles: newTiles,
            },
        }
    },

    [actions.REMOVE_TILE]: (
        state,
        { tileId }: actions.RemoveTile,
    ): IWelcomePage => {
        const grid = state.grid
        const newTiles = removeTile(grid.tiles, tileId)

        return {
            ...state,
            grid: {
                ...grid,
                tiles: newTiles,
            },
        }
    },
}

export default function reducer(
    state = initialState,
    action: Action,
): IWelcomePage {
    const handler: (state: IWelcomePage, action: Action) => IWelcomePage =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
